import { DATALIST} from './dataListTypes'
import axios from 'axios'
import i18n from 'i18next';
import { Trans } from 'react-i18next';
import React, { Component }  from 'react';
import Cookies from 'universal-cookie';

function loadData () {
  let dataTree = {
    id: 'root',
    name: <Trans>Layer operativi</Trans>, // TRADUCI
    children: [],
    visible: false
  }
  

  i18n.on('languageChanged', val => { console.log('languageChanged',val)
  dataTree.name = i18n.t("Layer operativi")})
  
  if(!window.configFile){
    axios.get(process.env.REACT_APP_PRODUZIONE_SHOWFILE,{headers: window.tp_headers}).then(response =>{
      if(!window.configFile) window.configFile = response.data
      dataTree = loadDataWorker(dataTree,response.data)
    }).catch(error=>{
        axios.get(process.env.REACT_APP_DEFAULT_CONFIGFILE).then(response =>{
          if(!window.configFile) window.configFile = response.data
          dataTree = loadDataWorker(dataTree,response.data)
        }).catch ((error) => {
          console.log("ERROR: No config file found!")
          this.setState({error:true})
        })
    })
  } else {
    dataTree = loadDataWorker(dataTree,window.configFile)
  }
 /*
  axios.post(process.env.REACT_APP_PRODUZIONE_SHOWFILE,{name: "config_file.json"},{headers: {'x-api-key': window.tp_key?window.tp_key:process.env.REACT_APP_API_KEY}})
   .then(response =>{                                      
   response.data.serviceOnScreen.services.map((element,indexX) => {
      var children = []
      
      element.layersName.map((x,indexY) => {
        if(!element.layersDisplayName) element.layersDisplayName = element.layersName
        children.push({id: `${indexX + 1}${indexY + 1}`, name:x,displayName:element.layersDisplayName[indexY],infoField:element.infoFields.layers[indexY],visible: false,opacity: "1",serviceUrl:element.serviceUrl,children: [{id: `${indexX + 1}${indexY + 1}${indexX + 1}`,name:"", layerName:x,serviceUrl:element.serviceUrl}]})
        return null
      })
      dataTree.children.push({id: indexX,name:element.name, children:children,element:element, visible: false})
      
      return null
    })
    
     return dataTree
      
                                                               })
  .catch(error=>{
  }) */
   return dataTree                                                 
  }

  function loadDataWorker (dataTree,data) {
    try {                                         
     data.serviceOnScreen.services.map((element,indexX) => {
        var children = []
        
        element.layersName.map((x,indexY) => {
          if(!element.layersDisplayName) element.layersDisplayName = element.layersName
          children.push({id: `${indexX + 1}${indexY + 1}`, name:x,displayName:element.layersDisplayName[indexY],infoField:element.infoFields.layers[indexY],visible: false,opacity: "1",serviceUrl:element.serviceUrl,children: [{id: `${indexX + 1}${indexY + 1}${indexX + 1}`,name:"", layerName:x,serviceUrl:element.serviceUrl}]})
          return null
        })
        dataTree.children.push({id: indexX,name:element.name, children:children,element:element, visible: false})
        
        return null
      })
      
       return dataTree
       
    } catch(error) {}
     return dataTree                                                 
  }

const initialState = {
    data: loadData()
}

const dataListReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case DATALIST:
            
            return {
                data: action.load
            }
    
        default:
          return state
    }

}


export default dataListReducer;